import React from 'react';

import SimpleForm from '../UI/SimpleForm';

import * as formValidation from '../../util/formValidationMethods';

const changePasswordForm = ({onSubmit, ...otherProps}) => {
    const formElements = {
        old_password: {
            type: 'password', 
            placeholder: 'Old Password', 
            validate: [formValidation.required], 
            autoFocus: true
        }, 
        new_password: {
            type: 'password', 
            placeholder: 'New Password', 
            validate: [formValidation.required, formValidation.minLength7]
        }, 
        new_password_confirm: {
            type: 'password', 
            placeholder: 'Confirm New Password', 
            validate: [formValidation.required, formValidation.minLength7]
        }, 
    };

    return (
        <SimpleForm 
            form="ChangePasswordForm" 
            title="Change Password" 
            formElements={formElements} 
            onSubmit={onSubmit} 
            {...otherProps} />
    );
}

export default changePasswordForm;